import { defineStore } from 'pinia';

/**
 * Layout store - manages layout and theme settings
 */
export const useLayoutStore = defineStore('layout', {
  // State
  state: () => ({
    // Global layout state
    isSidebarHidden: false,
    isMobileSidebarActive: false,
    isFixedWidth: false,

    // Layout module state
    layoutType: localStorage.getItem('layoutType') || 'vertical',
    topbar: localStorage.getItem('topbar') || 'light',
    mode: localStorage.getItem('mode') || 'light',
    position: localStorage.getItem('position') || 'fixed',
    sidebarView: localStorage.getItem('sidebarView') || 'default',
    sidebarColor: localStorage.getItem('sidebarColor') || 'light',
    sidebarCaption: localStorage.getItem('sidebarCaption') || 'false',
    direction: localStorage.getItem('direction') || 'ltr',
    color: localStorage.getItem('color') || 'preset-neutral',
    layoutTheme: localStorage.getItem('layoutTheme') || 'default',
  }),

  // Getters
  getters: {
    // Get if layout is using fixed width
    getIsFixedWidth: (state) => state.isFixedWidth,
  },

  // Actions
  actions: {
    // Toggle sidebar visibility
    toggleSidebar() {
      this.isSidebarHidden = !this.isSidebarHidden;
    },

    // Toggle mobile sidebar
    toggleMobileSidebar() {
      this.isMobileSidebarActive = !this.isMobileSidebarActive;
    },

    // Set full width layout
    setFullWidth() {
      this.isFixedWidth = false;
      localStorage.setItem('isFixedWidth', 'false');
    },

    // Set fixed width layout
    setFixedWidth() {
      this.isFixedWidth = true;
      localStorage.setItem('isFixedWidth', 'true');
    },

    // Change layout type (vertical, horizontal, etc.)
    changeLayoutType(layoutType) {
      this.layoutType = layoutType;
      localStorage.setItem('layoutType', layoutType);
      document.body.removeAttribute('style');
    },

    // Change topbar style (light, dark)
    changeTopbar(topbar) {
      this.topbar = topbar;
      localStorage.setItem('topbar', topbar);
    },

    // Change mode (light, dark)
    changeMode(mode) {
      this.mode = mode;
      localStorage.setItem('mode', mode);
    },

    // Change position (fixed, absolute, relative)
    changePosition(position) {
      this.position = position;
      localStorage.setItem('position', position);
    },

    // Change sidebar view
    changeSidebarView(sidebarView) {
      this.sidebarView = sidebarView;
      localStorage.setItem('sidebarView', sidebarView);
    },

    // Change sidebar color
    changeSidebarColor(sidebarColor) {
      this.sidebarColor = sidebarColor;
      localStorage.setItem('sidebarColor', sidebarColor);
    },

    // Change sidebar caption visibility
    changeSidebarCaption(sidebarCaption) {
      this.sidebarCaption = sidebarCaption;
      localStorage.setItem('sidebarCaption', sidebarCaption);
    },

    // Change text direction (ltr, rtl)
    changeDirection(direction) {
      this.direction = direction;
      localStorage.setItem('direction', direction);
    },

    // Change theme color
    changeColor(color) {
      this.color = color;
      localStorage.setItem('color', color);
    },

    // Change overall theme
    changeTheme(layoutTheme) {
      this.layoutTheme = layoutTheme;
      localStorage.setItem('layoutTheme', layoutTheme);
    },

    // Initialize layout settings from localStorage
    initializeLayout() {
      // Apply theme
      document.body.setAttribute('data-pc-theme', this.mode);

      // Apply direction
      document.body.setAttribute('data-pc-direction', this.direction);

      // Apply sidebar color
      document.body.setAttribute('data-pc-sidebar-theme', this.sidebarColor);

      // Apply sidebar caption
      document.body.setAttribute(
        'data-pc-sidebar-caption',
        this.sidebarCaption
      );

      // Apply preset color
      document.body.setAttribute('data-pc-preset', this.color);
    },
  },
});
